module.exports = __webpack_public_path__ + "img/dis.e6891ce4.svg";